import { useState, useEffect } from 'react';

export const useTypewriter = (words, typingSpeed = 100, deletingSpeed = 50, delay = 2000) => {
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeout;
    const currentWord = words[wordIndex];

    const type = () => {
      setIsTyping(true);

      if (isDeleting) {
        setDisplayText(currentWord.substring(0, displayText.length - 1));
        timeout = setTimeout(type, deletingSpeed);
      } else {
        setDisplayText(currentWord.substring(0, displayText.length + 1));
        timeout = setTimeout(type, typingSpeed);
      }

      if (!isDeleting && displayText === currentWord) {
        setIsTyping(false); // Pause blinking while waiting
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          setIsDeleting(true);
          setIsTyping(true); // Resume typing (deleting)
          type();
        }, delay);
      } else if (isDeleting && displayText === '') {
        setIsDeleting(false);
        setWordIndex((prev) => (prev + 1) % words.length);
        clearTimeout(timeout);
        timeout = setTimeout(type, 500); // Short pause before next word
      }
    };

    // Need to clear existing timeout to avoid overlaps if effect re-runs
    timeout = setTimeout(type, isTyping ? (isDeleting ? deletingSpeed : typingSpeed) : 100);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, wordIndex, words, typingSpeed, deletingSpeed, delay]);

  return { displayText, isTyping };
};
